import SsembleSpinner from './ssembleSpinner';
function Loading() {
	return (
		<section className="youtube-down-sec tools-sec">
			<div className="container">
				<div className="loadingScreen">
					<SsembleSpinner />
				</div>
			</div>
		</section>
	);
}

export default Loading;
